import BookingForm from "./BookingForm";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";

export default function AppointmentDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[calc(100dvh-16px)] w-[calc(100vw-16px)] max-w-[950px] gap-3 overflow-y-auto overscroll-contain rounded-[14px] border-0 bg-white p-4 shadow-[0_24px_80px_rgba(6,56,111,0.25)] sm:max-h-[92vh] sm:w-full sm:gap-4 sm:rounded-[18px] sm:p-8">
        <DialogHeader className="pr-8 text-left">
          <DialogTitle className="text-[25px] font-extrabold leading-tight text-[#071746] sm:text-[42px]">
            Reserve Your Smile
          </DialogTitle>
          <DialogDescription className="text-[13px] leading-relaxed text-paradise-slate sm:text-[18px]">
            Complete the form below to book your appointment with our specialized dental team.
          </DialogDescription>
        </DialogHeader>
        <BookingForm variant="popup" />
      </DialogContent>
    </Dialog>
  );
}
